import { AppLayout } from '@layouts/AppLayout'
import { router, Stack } from 'expo-router'
import { YStack, Text, View } from 'tamagui'
import { Button } from '@components/Button'
import { HeroIcon } from '@components/HeroIcon'

export default function NotFoundScreen() {
  const handleBack = () => router.back()

  return (
    <AppLayout
      backRoute={{
        label: 'Voltar',
      }}
      hasFooter={false}
    >
      <Stack.Screen options={{ title: 'Página não encontrada' }} />
      <YStack
        flex={1}
        alignItems="center"
        justifyContent="center"
        padding="$spacing-inset-lg"
        gap="$spacing-md"
      >
        <View
          marginBottom="$spacing-md"
          bg="$bg-surface-raised"
          borderRadius="$border-radius-pill"
          padding="$spacing-md"
          width={64}
          height={64}
          alignItems="center"
          justifyContent="center"
        >
          <HeroIcon
            icon={['fal', 'globe-pointer']}
            size={32}
            color="$icon-primary"
          />
        </View>
        <Text
          fontFamily="$mulishRegular"
          color="$text-primary"
          textAlign="center"
          fontSize="$font-size-md"
          fontWeight="700"
        >
          Este conteúdo está disponível apenas na versão web.
        </Text>
        <Text
          fontFamily="$mulishRegular"
          color="$text-primary"
          textAlign="center"
          fontSize="$font-size-xxs"
        >
          Acesse pelo navegador para visualizar.
        </Text>
        <Button
          onPress={handleBack}
          marginTop="$spacing-md"
          width="100%"
          size="large"
          maxWidth={340}
        >
          Voltar para página anterior
        </Button>
      </YStack>
    </AppLayout>
  )
}
